// Pagina pubblica: il candidato chiede il link per impostare la password (primo accesso o password dimenticata)
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TextField, Button, Typography } from '@material-ui/core';

import PasswordResetLayout, { usePasswordResetStyles } from './PasswordResetLayout';
import { richiediLink } from './passwordResetApi';

const RichiestaResetPage = () => {
    const classes = usePasswordResetStyles();
    const [email, setEmail] = useState('');
    const [stato, setStato] = useState('form'); // form | invio | inviata | errore

    const handleSubmit = async e => {
        e.preventDefault();
        setStato('invio');
        try {
            await richiediLink(email.trim());
            setStato('inviata');
        } catch (error) {
            setStato('errore');
        }
    };

    return (
        <PasswordResetLayout title="PRIMO ACCESSO O PASSWORD DIMENTICATA">
            {stato === 'inviata' ? (
                <Typography variant="body1" className={classes.text}>
                    Se l'indirizzo è registrato, riceverai a breve un'email con il link per impostare la password.
                    Il link vale 60 minuti e si può usare una sola volta.
                    Se non la trovi, controlla anche nella posta indesiderata.
                </Typography>
            ) : (
                <form className={classes.form} onSubmit={handleSubmit}>
                    <Typography variant="body1" className={classes.text}>
                        Scrivi l'email con cui sei stato invitato al quiz: ti invieremo un link per impostare la password.
                    </Typography>
                    <TextField
                        label="Email"
                        type="email"
                        autoComplete="email"
                        variant="outlined"
                        required
                        fullWidth
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        className={classes.submit}
                        disabled={stato === 'invio'}
                    >
                        Invia link
                    </Button>
                    {stato === 'errore' && (
                        <Typography variant="body2" color="error" className={classes.text}>
                            Non è stato possibile inviare la richiesta. Riprova tra qualche minuto.
                        </Typography>
                    )}
                </form>
            )}
            <Link to="/login" className={classes.link}>Torna alla pagina di accesso</Link>
        </PasswordResetLayout>
    );
};

export default RichiestaResetPage;
